import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(null);

function defaultLang() {
  return localStorage.getItem('jahbath_student_lang') || 'ar';
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(defaultLang);

  const setLang = (l) => {
    localStorage.setItem('jahbath_student_lang', l);
    setLangState(l);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
